import { Inject, Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { Observable, Subject } from 'rxjs';
import { ChangeLayoutEvent } from '../../models';
import { CASTING_HUB_URL } from '../../tokens';

@Injectable()
export class CastingHubService {
  private readonly _sessionStarted = new Subject<void>();
  private readonly _sessionEnded = new Subject<void>();
  private readonly _changeLayout = new Subject<ChangeLayoutEvent>();

  private _hub: HubConnection;

  public constructor(@Inject(CASTING_HUB_URL) hubUrl: string) {
    this._hub = new HubConnectionBuilder()
      .withUrl(hubUrl)
      .withAutomaticReconnect()
      .configureLogging(LogLevel.Information)
      .build();

    this._hub.on('SessionStarted', () => this._sessionStarted.next());
    this._hub.on('SessionEnded', () => this._sessionEnded.next());
    this._hub.on('ChangeLayout', (layout, widgets) => this._changeLayout.next({ layout, widgets }));
  }

  public get sessionStarted$(): Observable<void> {
    return this._sessionStarted.asObservable();
  }

  public get sessionEnded$(): Observable<void> {
    return this._sessionEnded.asObservable();
  }

  public get changeLayout$(): Observable<ChangeLayoutEvent> {
    return this._changeLayout.asObservable();
  }

  public async connect(): Promise<void> {
    await this._hub.start();
  }

  public async disconnect(): Promise<void> {
    await this._hub.stop();
  }

  public async join(sessionId: string): Promise<void> {
    await this._hub.send('Join', sessionId);
  }

  public async leave(sessionId: string): Promise<void> {
    await this._hub.send('Leave', sessionId);
  }
}
